import { LegendWithOneLineBulletFlex } from "@similarweb/ui-components";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import type { IChartData } from "./useChartData";

export const Legend = ({ chartData }: { chartData: IChartData[] }) => {
    const translate = useTranslation();

    return (
        <Stack
            gap="12px"
            flex="1"
            data-automation="my-channels-overview-legend"
        >
            <Flex justifyContent="space-between">
                <Text fontVariant="caption">{translate("bt.report.channels.my-channels-overview.legend.channel")}</Text>
                <Text fontVariant="caption">
                    {translate("bt.report.channels.my-channels-overview.legend.traffic-share")}
                </Text>
            </Flex>
            <Stack gap="8px">
                {chartData.map((item) => (
                    <LegendWithOneLineBulletFlex
                        key={item.name}
                        text={item.name}
                        value={item.y == null ? translate("common.n/a") : `${item.y}%`}
                        labelColor={item.color}
                        dataAutomation="my-channels-overview-legend-item"
                    />
                ))}
            </Stack>
        </Stack>
    );
};
